import { gql } from '@apollo/client';

export const GET_WAITINGLIST_ATTACHMENT_DOWNLOAD_URL = gql`
  query GetWaitingListAttachmentDownloadUrl(
    $id: String!
    $attachmentUid: String!
    $source: WaitingListAttachmentSource!
  ) {
    waitingListAttachmentDownloadUrl(
      id: $id
      attachmentUid: $attachmentUid
      source: $source
    ) {
      preSignedUrl
      expiresAt
    }
  }
`;
